// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I0IS","toggle":"styles_toggle__2oUI-","preview":"styles_preview__301R6"};